<template>
    <div class="hot-update">
        <page-title></page-title>
        <div class="container">
            <tool-bar>
                <template v-slot:right>
                    <el-button type="primary" @click="updateVisible = true">上传更新包</el-button>
                </template>
            </tool-bar>
            <el-table 
                :data="tableData" 
                style="width: 100%; margin-top: 10px;"
                v-loading="listLoading"
                element-loading-text="正在上传"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)">
                <el-table-column label="版本名称" prop="version_number" align="center"></el-table-column>
                <el-table-column label="版本号" prop="real_version_number" align="center"></el-table-column>
                <el-table-column label="更新内容" prop="version_desc" align="center"></el-table-column>
                <el-table-column label="更新时间" prop="created_at" align="center"></el-table-column>
                <el-table-column label="状态" align="center">
                    <template #default="scope">
                        <el-tag type="danger" v-if="scope.row.status == 0">禁用</el-tag>
                        <el-tag v-else>启用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120px">
                    <template #default="scope">
                        <el-button type="text" v-if="scope.row.status == 0" @click="setStatus(scope.row)">开启</el-button>
                        <el-button type="text" v-else-if="scope.row.status == 1" style="color: #909399;" @click="setStatus(scope.row)">禁用</el-button>
                        <el-popconfirm
                            title="确定删除吗？"
                            @confirm="del(scope.row)">
                            <template #reference>
                                <el-button type="text" style="color: #F56C6C;">删除</el-button>
                            </template>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    layout="total, prev, pager, next"
                    v-model:currentPage="historyP"
                    :total="historyCount"
                    @current-change="getList">
                </el-pagination>
            </div> 
        </div>
        <el-dialog v-model="updateVisible" title="上传更新包">
            <div class="upload-zip">
                <el-upload
                    class="upload-btn"
                    drag
                    action=""
                    accept=".zip, .wgt"
                    ref="upload"
                    :http-request="uploadFile">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <template #tip>
                        <div class="el-upload__tip">
                        只能上传 zip/wgt 文件
                        </div>
                    </template>
                </el-upload>
                <el-form label-width="140px" style="margin-top: 40px;">
                    <el-form-item label="应用版本名称">
                        <el-input placeholder="应用版本名称，必须高于上一个版本的值，格式：1.0.0" v-model="form.version_number"></el-input>
                    </el-form-item>
                    <el-form-item label="应用版本号">
                        <el-input placeholder="应用版本号，必须高于上一个版本的值，格式：100" v-model.number="form.real_version_number"></el-input>
                    </el-form-item>
                    <el-form-item class="更新内容">
                        <el-input placeholder="更新内容" type="textarea" rows="4" v-model="form.version_desc"></el-input>
                    </el-form-item>
                </el-form>
                <el-button type="primary" style="margin-top: 20px; width: 220px;" :loading="addLoading" @click="add">确  定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import pageTitle from '@/components/page-title/index.vue';
import toolBar from '@/components/tool-bar/index.vue';

export default {
    components: {
        pageTitle,
        toolBar
    },
    data() {
        return {
            id: this.$route.query.id,
            tableData: [], // 更新列表
            updateVisible: false, // 上传更新包的对话框
            form: { // 上传更新包的表单
                zip_file: null,
                version_number: null,
                real_version_number: null,
                version_desc: null,
            },
            addLoading: false, // 添加更新包loading
            listLoading: false, // 列表loaidng
            historyP: 1,
            historyCount: 0,
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        uploadFile(e) { // 上传更新包
            console.log(e);
            this.form.zip_file = e.file;
        },
        async add() { // 添加热更新
            if(!this.form.zip_file) {
                this.$message.error("请上传更新包");
                return false;
            } else if(!this.form.version_number) {
                this.$message.error('请填写应用版本名称');
                return false;
            } else if(!this.form.real_version_number) {
                this.$message.error('请填写应用版本号');
                return false;
            }

            let fd = new FormData();
            let token = localStorage.getItem('token');
            fd.append('token', token);
            fd.append('app_id', this.id);
            Object.keys(this.form).forEach(key => {
                fd.append(key, this.form[key]);
            })

            this.addLoading = true;
            const res = await this.$api.hotUpdateAdd(fd);
            this.addLoading = false;
            if(res.data.code == 0) {
                this.$message({
                    type: 'success',
                    message: '添加成功'
                });
                this.updateVisible = false;
                this.$refs.upload.clearFiles();
                Object.keys(this.form).forEach(key => {
                    this.form[key] = null;
                });
                this.getList();
            } else {
                this.$message.error(res.data.msg);
            }
        },
        async getList() { // 获取列表
            this.listLoading = true;
            const res = await this.$api.hotUpdateList({
                p: this.historyP,
                limit: 10,
                app_id: this.id,
            });
            this.listLoading = false;
            if(res.data.code == 0) {
                this.tableData = res.data.data.list;
                this.historyCount = res.data.data.count;
            } else {
                this.$message.error(res.data.msg);
            }
        },
        async setStatus(row) { // 设置状态
            this.listLoading = true;
            const res = await this.$api.hotUpdateSetStatus({
                id: row.id,
                status: row.status == 1 ? 0 : 1
            });
            this.listLoading = false;
            if(res.data.code == 0) {
                this.$message({
                    type: 'success',
                    message: '修改成功'
                });
                this.getList();
            } else {
                this.$message.error(res.data.msg);
            }
        },
        async del(row) {
            this.listLoading = true;
            const res = await this.$api.hotUpdateDel({
                id: row.id,
                status: row.status == 1 ? 0 : 1
            });
            this.listLoading = false;
            if(res.data.code == 0) {
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });
                this.getList();
            } else {
                this.$message.error(res.data.msg);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .upload-zip {
        text-align: center;
    }
</style>